import { z } from "zod";

import { MetaDataSchema } from "@/schemas/meta-data";

import { ERROR_TYPE } from "@/utils";

import { CompanyCategoryResultsSchema, OrganizationSchema } from "../../Apollo/schema/get-people";
import { ColumnValueSchema } from "../../List/schema/columnValue";
import { TrackerSchema } from "./profileTracker";
import { TrackerPersonSchema } from "./trackerPerson";

const { REQUIRED } = ERROR_TYPE;

export const TrackerOrganizationSchema = z.object({
	id: z.number(),
	name: z.string().min(4, { message: REQUIRED }).trim(),
	tracker: TrackerSchema,
	organization: OrganizationSchema,
	holdingOrganization: OrganizationSchema.optional(),
	columns: z.array(ColumnValueSchema),
	columnsHistory: z.array(ColumnValueSchema).optional(),
	trackerPersons: z.array(TrackerPersonSchema).optional(),
	scoreCompanyCategoryResult: CompanyCategoryResultsSchema.nullable().optional(),
	/** Null until the row's first successful signal scan (PREC-3616). */
	signalLastCheckedAt: z.coerce.date().nullish(),
	/** When the company was added to the tracker — feeds the 24h "looking for signals" window. */
	createdAt: z.coerce.date().optional(),
});

export const TrackerOrganizationResponseSchema = z.object({
	data: z.array(TrackerOrganizationSchema),
	meta: MetaDataSchema,
});

export type TrackerOrganization = z.infer<typeof TrackerOrganizationSchema>;

export type TrackerOrganizationResponse = z.infer<typeof TrackerOrganizationResponseSchema>;

export const AddPeopleToTrackerResponseSchema = z.object({
	addedCount: z.coerce.number(),
});

export type AddPeopleToTrackerResponse = z.infer<typeof AddPeopleToTrackerResponseSchema>;
